import { render } from "./keywords.vue?vue&type=template&id=64e2a12b&ts=true"
import script from "./keywords.vue?vue&type=script&lang=ts"
export * from "./keywords.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__